import { useAuth } from "@clerk/clerk-react";
import { Navigate } from "react-router-dom";
import { AppSplash } from "../components";
import { useCurrentUser } from "../utils/context/UserProvider";

export default function ProtectedRoute({ children }) {
  const { isLoaded, isSignedIn } = useAuth();
  const { loading: userLoading, error } = useCurrentUser();

  if (!isLoaded) return <AppSplash text="Loading..." />;
  if (!isSignedIn) return <Navigate to="/login" replace />;

  if (userLoading) return <AppSplash text="Loading your account..." />;

  if (error) return <Navigate to="/login" replace />;

  return children;
}